import React from "react";
import { Route, BrowserRouter as Router, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Nav from "./Nav";
import Footer from "./Footer";
import SpecialOptions from "./3/SpecialOptions";
import OrderForm from "./4/OrderForm";
import ChooseLockSystem from "./2/ChooseLockSystem";
import LockConfigurator from "./1/LockConfigurator";
import Home from "./Home";
import AdminPane from "./adminPane/AdminPanel";

// Komponent do wykrywania orientacji urządzenia
const OrientationWarning = () => {
  const [isPortrait, setIsPortrait] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const checkOrientation = () => {
      // Sprawdź czy urządzenie jest w trybie portretowym i ma szerokość < 960px
      setIsPortrait(window.innerHeight > window.innerWidth && window.innerWidth < 960);
    };

    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  // Wyświetl komunikat tylko na stronie pierwszej (konfigurator - ścieżka "/1")
  if (!isPortrait || location.pathname !== '/1') return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <style>
        {`
          @keyframes rotatePhone {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(90deg); }
            50% { transform: rotate(180deg); }
            75% { transform: rotate(270deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          
          .rotate-icon {
            animation: rotatePhone 2s ease-in-out infinite;
            font-size: 48px;
            margin-bottom: 20px;
          }
          
          .bounce-text {
            animation: bounce 1s ease-in-out infinite;
          }
        `}
      </style>

      <img
        src="/img/rotate-phone.svg"
        alt="rotate"
        className="rotate-icon"
        style={{ width: 96, height: 96, marginBottom: 20, filter: 'invert(1)' }}
      />

      <h2 className="bounce-text" style={{ marginBottom: '10px', fontSize: '24px' }}>
        Bitte drehen Sie Ihr Gerät
      </h2>

      <p style={{ fontSize: '18px', marginBottom: '20px' }}>
        Für die beste Erfahrung verwenden Sie die App im Querformat
      </p>

      <div style={{
        fontSize: '36px',
        transform: 'rotate(90deg)',
        animation: 'bounce 1s ease-in-out infinite'
      }}>
        ↻
      </div>
    </div>
  );
};

const useRoutes = () => {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="1" element={<LockConfigurator />} />
      <Route path="2" element={<ChooseLockSystem />} />
      <Route path="3" element={<SpecialOptions disabled={false} />} />
      <Route path="4" element={<OrderForm />} />
      <Route path="admin" element={<AdminPane />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <>
        <OrientationWarning />
        <div className="App">
          <Nav />
          {useRoutes()}
          <div style={{ width: "1px", height: "80px" }}></div>
          <Footer />
        </div>
      </>

    </Router>
  );
}

export default App;
